// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"SignalChip_iconAndTextGrouping__zP_WH"};